import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';

/* istanbul ignore next */
export default universal(
    universalImport({
        chunkName: () => 'OrderConfirmationPage',
        path: () => path.join(__dirname, './OrderConfirmationPage'),
        resolve: () => require.resolveWeak('./OrderConfirmationPage'),
        load: () =>
            Promise.all([
                import(/* webpackChunkName: "OrderConfirmationPage" */ './OrderConfirmationPage'),
            ]).then((proms) => proms[0]),
    })
);
